import {
  initialState,
  Actions,
  State,
  PUBLISH_MODULES,
  PUBLISH_MODULES_SUCCESS,
  PUBLISH_MODULES_ERROR,
  RESET_PUBLISH_MODULES,
} from "../../types/module/publish-modules";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case PUBLISH_MODULES:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case PUBLISH_MODULES_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case PUBLISH_MODULES_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_PUBLISH_MODULES:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
